module.exports = __webpack_public_path__ + "static/media/asusena_rda.ab5f13b9.png";